var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3077 1.33333H7.69231C6.97826 1.33333 6.29346 1.58874 5.78856 2.04337C5.28365 2.49801 5 3.11462 5 3.75757V20.2424C5 20.8854 5.28365 21.502 5.78856 21.9566C6.29346 22.4113 6.97826 22.6667 7.69231 22.6667H16.3077C17.0217 22.6667 17.7065 22.4113 18.2114 21.9566C18.7163 21.502 19 20.8854 19 20.2424V3.75757C19 3.11462 18.7163 2.49801 18.2114 2.04337C17.7065 1.58874 17.0217 1.33333 16.3077 1.33333ZM12 21.697C11.1062 21.697 10.3846 21.0473 10.3846 20.2424C10.3846 19.4376 11.1062 18.7879 12 18.7879C12.8938 18.7879 13.6154 19.4376 13.6154 20.2424C13.6154 21.0473 12.8938 21.697 12 21.697ZM16.8462 17.8182H7.15385V4.24242H16.8462V17.8182Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.031bc3c6dfbf34434e0f52a0d8f60bec.svg";
export { ForwardRef as ReactComponent };